export enum SidebarEntity {
  ACTIVITY = 'ACTIVITY',
  ACTIVITY_GROUP = 'ACTIVITY_GROUP',
  ROOM = 'ROOM',
}
